var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',[_c('v-container',[_c('v-card',{attrs:{"flat":""}},[_c('match-list',{attrs:{"matches":_vm.matches,"no-results-text":"No upcoming matches found..."}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }